<div
  class="card ziro-card mb-4"
  [ngClass]="{ disabled: isDisabled() && !isError() && !isRefreshing() }"
  (click)="onCardClick($event)"
>
  <div
    class="card-body d-flex flex-column"
    [ngClass]="{ 'not-allowed-cursor': isDisabled() && !isError() && !isRefreshing() }"
  >
    <ziro-migrations-card-header [label]="label()" [labelTooltip]="labelTooltip()"></ziro-migrations-card-header>

    <div class="d-flex justify-content-center align-items-center flex-grow-1 w-100">
      @if (isRefreshing() || (!isError() && !isDisabled() && (!data() || data()?.length === 0))) {
        <div class="text-center">
          <i data-automation="card-refreshing" class="icon {{ ZiroIcons.LOADING }}"></i>
        </div>
      } @else if (isError()) {
        <div class="text-center" data-automation="card-error">
          <i class="icon {{ ZiroIcons.CIRCLE_EXCLAMATION }} text-danger"></i>
          <h5 data-automation="card-error-title">
            {{ 'tkey;migrations.cisco.directory_numbers_report.dashboard.usage_type.error.title' | translate }}
          </h5>
          <p data-automation="card-error-description">
            {{ 'tkey;migrations.cisco.directory_numbers_report.dashboard.usage_type.error.description' | translate }}
          </p>
          <ziro-button
            [dataAutomation]="'card-error-refresh-button'"
            [label]="'tkey;migrations.cisco.directory_numbers_report.dashboard.refresh'"
            [icon]="ZiroIcons.REFRESH"
            (clicked)="onErrorButtonClick()"
          ></ziro-button>
        </div>
      } @else if (isDisabled()) {
        <div class="text-center" data-automation="card-disabled">
          <i class="icon {{ ZiroIcons.CIRCLE_EXCLAMATION }} text-muted"></i>
          <h5 data-automation="card-disabled-title">
            {{ disabledText()?.header | translate }}
          </h5>
          <p data-automation="card-disabled-description">
            {{ disabledText()?.description | translate }}
          </p>
        </div>
      } @else {
        <div data-automation="donut-chart-container" class="d-flex align-items-center w-100">
          <div class="chart-container d-flex justify-content-center">
            <div data-automation="donut-chart-total-count" class="chart-container--total-count">
              <div>{{ getTotalCountFormatted() }}</div>
              <div class="fs-6 mt-1">
                {{ totalSubtext() | translate }}
              </div>
            </div>
            <ngx-charts-pie-chart
              data-automation="donut-chart-pie-chart"
              [view]="[220, 220]"
              [scheme]="colorScheme()"
              [results]="data()"
              [legend]="false"
              [legendTitle]="''"
              [legendPosition]="LegendPosition.Right"
              [trimLabels]="false"
              [doughnut]="true"
              [tooltipText]="tooltipText"
              [customColors]="customColors()"
              (select)="onChartSegmentClick($event)"
            ></ngx-charts-pie-chart>
          </div>

          <div
            [class]="'legend flex-grow-1 ms-4 ' + (isScrollableLegend() ? 'me-3' : '')"
            data-automation="donut-chart-legend"
            [ngClass]="{ legend__scrollable: isScrollableLegend() }"
          >
            @for (entry of data(); track entry; let i = $index) {
              <div
                class="legend-item"
                [ngClass]="{ 'legend-item--hover': !entry.disableHoverEffect, 'me-2': isScrollableLegend() }"
              >
                <a
                  [routerLink]="entry.link"
                  [class]="'cursor-pointer text-decoration-none text-body d-flex align-items-center p-2'"
                  data-automation="donut-chart-legend-item"
                  [ngbTooltip]="entry.tooltipText"
                  [disableTooltip]="!entry.tooltipText"
                >
                  <div
                    class="legend-item--color-swatch me-2"
                    [style.background-color]="getLegendColor(entry.name, i)"
                  ></div>
                  <div>
                    <div class="legend-item--name font-regular fs-6" data-automation="donut-chart-legend-item-name">
                      {{ entry.name }}
                    </div>
                    <div class="legend-item--count" data-automation="donut-chart-legend-item-count">
                      {{ entry.value }}
                      {{ (entry.value === 1 ? legendCountLabelSingular() : legendCountLabelPlural()) | translate }}
                    </div>
                  </div>
                  <span
                    class="legend-item--percentage alert alert-inline alert-info ms-auto text-center align-self-start"
                    data-automation="donut-chart-legend-item-percentage"
                  >
                    <span>{{ getPercentage(entry.value) }}%</span>
                  </span>
                </a>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
